// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  :root {
    --bg-colour: #17242D;
    --text-colour: white;
    --uiElements-colour: #21303a;
  }
 
.MO_cswAEVtkSFjq1URgw{
  border: 2px solid black;
}

  ul li {
    font-weight: normal;
  }
  body {
    margin: 0;
    padding: 0;
    /* background-color: #0070cc !important; */
    /* overflow: hidden; */
  }
  
    
  .ZlzcpuLFRoUJUAOfu_OI{
    border-radius: 80px !important;
    border: double 2px #005293;
    background-image: linear-gradient(#fecb00, #fecb00);
    /* background-clip: padding-box, border-box; */
    cursor: pointer;
    padding: 10px 15px; /* Initial padding */
    align-items: center;
    justify-content: center;
    color: #005293;
    transition: padding 0.2s ease; /* Smooth transition for padding */
    font-weight: 900;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */
    text-shadow: 0px 0px 0px #008cff;
  }
    .ZlzcpuLFRoUJUAOfu_OI:hover {
      /* box-shadow: -4px -4px 0px #00C6FF, 4px 4px 0px #EE1D52; Add two drop shadows */
      box-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff0000, 0 0 70px #ff0000, 0 0 80px #ff0000, 0 0 100px #ff0000, 0 0 150px #ff00de;
      text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff0000, 0 0 70px #ff0000, 0 0 80px #ff0000, 0 0 100px #ff0000, 0 0 150px #ff00de;
      border: 1px solid red;
      background-color: rgba(0, 0, 255, 0.0);
      color: red;

      cursor: pointer; /* Change cursor on hover */
    }

    .wyvJIEH_QPeg448IwMd1 {
      position: relative;
      clear:left;
      display: block;
      text-align: center;
    }
  
  
  .IZHONrumCyswcVyir15N {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
    h1,
    p {
      position: relative;
      z-index: 1;
      text-align: center;
    }
    
    @keyframes XZQDsjrcPZi9xamLTfUJ {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
      100% {
        transform: translateY(0);
      }
    }
    .moUMC4FeilyAryZm2VQu {
      animation-name: XZQDsjrcPZi9xamLTfUJ;
      animation-duration: 3s;
      animation-iteration-count: infinite;
      animation-timing-function: ease-in-out;
    }
    
   
    
   
    .TBoRdF056cAKiJytuM3G{
      width: 19px;
      height: 24;
      float:left;
    }
    
    .RerkZUf4a3bGKaQe66MS {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .xImlrI8EtvkGrREygP4s.U0gYyJeZCNHw7ouxPy6_ {
      color: blue;
    }
    #rbqrO8mQzSomQ11rTyPQ{
      width: 100%;
      position: relative;
      display: block;
      padding: 1% 1%;
      border: 1px;
      border: 3px solid #ffffff;
      margin-top: 10px;
    }  
    
    h1, h2, h3, h4 {
      font-family: 'Roboto';
      color: var(--text-colour);
    }   
    
    
    ._31diwsPwba1bK3L9DaR2 {
    display: block; /* remove any default spacing and padding */
    max-width: 15%; /* ensure the images scale properly */
    height: auto; /* maintain aspect ratio */
    padding-right:20px;
    
  }
  
  .JsTLJw2P_URCzRwAvAl9 {
    display: block; /* remove any default spacing and padding */
    max-width: 400px; /* ensure the images scale properly */
    height: auto; /* maintain aspect ratio */
    padding-left: 20px;
  }
  
  .CUsH8xvzrJ9spVDoTG8B{
    display: block;
    margin-left: auto;
    margin-right: auto;
      width: 50%;
      height: auto;
      border: 3px solid var(--text-colour);
    }
    
    
  
  
  hr { 
    /* border: 3px solid #ffffff; */
    width: 20%;
    border-color: "blue";
  } 

h3 {
  text-align: center;
}

#dmwySiaGDAcZbk0tk9qC button {
  
}

/* h1 span #logoText {
  font-family: 'Roboto' !important;
  letter-spacing: 1px;
  transition: padding 0.2s ease;
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
  /* font-size: large !important; 
} 
*/


.g3qQHxk0LDUI8m3CUWTG {
  font-family: 'Roboto' !important;
  letter-spacing: 1px;
  transition: padding 0.2s ease;
  color: #fecb00;
  font-size: 58px;
}

@media screen and (max-width: 400px) {
  .g3qQHxk0LDUI8m3CUWTG {
    font-family: 'Roboto' !important;
    letter-spacing: 1px;
    transition: padding 0.2s ease;
    color: #fecb00;
    font-size: 30px;
  }

}

@media screen and (max-width: 768px) {
  .MkClfXFHp3oRZK7byVW1 {
    width: 400px;
    justify-content: center;
    display: flex;
  }

}

.MkClfXFHp3oRZK7byVW1 {
  max-width: 100%;
  border-radius: 40px;
  
}

ul {
  text-align: center;
  list-style: none;
  padding-left: 0;
  margin-left: 0;
}

.mTYjHSQcOpMipa3wxA2Z {
  justify-content: right !important;
  padding-left: 0;
  padding-right: 0;
}

@media screen and (max-width: 768px) {
  .mTYjHSQcOpMipa3wxA2Z {
    justify-content: center !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Home.module.css"],"names":[],"mappings":";EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,4BAA4B;EAC9B;;AAEF;EACE,uBAAuB;AACzB;;EAEE;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,UAAU;IACV,0CAA0C;IAC1C,sBAAsB;EACxB;;;EAGA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,mDAAmD;IACnD,8CAA8C;IAC9C,eAAe;IACf,kBAAkB,EAAE,oBAAoB;IACxC,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,6BAA6B,EAAE,kCAAkC;IACjE,gBAAgB;IAChB,uCAAuC,EAAE,8BAA8B;IACvE,gCAAgC;EAClC;IACE;MACE,iFAAiF;MACjF,mJAAmJ;MACnJ,oJAAoJ;MACpJ,qBAAqB;MACrB,sCAAsC;MACtC,UAAU;;MAEV,eAAe,EAAE,2BAA2B;IAC9C;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,cAAc;MACd,kBAAkB;IACpB;;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;IAEE;;MAEE,kBAAkB;MAClB,UAAU;MACV,kBAAkB;IACpB;;IAEA;MACE;QACE,wBAAwB;MAC1B;MACA;QACE,4BAA4B;MAC9B;MACA;QACE,wBAAwB;MAC1B;IACF;IACA;MACE,oCAAqB;MACrB,sBAAsB;MACtB,mCAAmC;MACnC,sCAAsC;IACxC;;;;;IAKA;MACE,WAAW;MACX,UAAU;MACV,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,WAAW;IACb;IACA;MACE,WAAW;MACX,kBAAkB;MAClB,cAAc;MACd,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;MACE,qBAAqB;MACrB,yBAAyB;IAC3B;;;IAGA;IACA,cAAc,EAAE,2CAA2C;IAC3D,cAAc,EAAE,qCAAqC;IACrD,YAAY,EAAE,0BAA0B;IACxC,kBAAkB;;EAEpB;;EAEA;IACE,cAAc,EAAE,2CAA2C;IAC3D,gBAAgB,EAAE,qCAAqC;IACvD,YAAY,EAAE,0BAA0B;IACxC,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;MAChB,UAAU;MACV,YAAY;MACZ,oCAAoC;IACtC;;;;;EAKF;IACE,+BAA+B;IAC/B,UAAU;IACV,oBAAoB;EACtB;;AAEF;EACE,kBAAkB;AACpB;;AAEA;;AAEA;;AAEA;;;;;;;CAOC;;;AAGD;EACE,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,gCAAgC;IAChC,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;IACd,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,aAAa;EACf;;AAEF;;AAEA;EACE,eAAe;EACf,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF","sourcesContent":["\n  :root {\n    --bg-colour: #17242D;\n    --text-colour: white;\n    --uiElements-colour: #21303a;\n  }\n \n.imageBlackBorder{\n  border: 2px solid black;\n}\n\n  ul li {\n    font-weight: normal;\n  }\n  body {\n    margin: 0;\n    padding: 0;\n    /* background-color: #0070cc !important; */\n    /* overflow: hidden; */\n  }\n  \n    \n  .button{\n    border-radius: 80px !important;\n    border: double 2px #005293;\n    background-image: linear-gradient(#fecb00, #fecb00);\n    /* background-clip: padding-box, border-box; */\n    cursor: pointer;\n    padding: 10px 15px; /* Initial padding */\n    align-items: center;\n    justify-content: center;\n    color: #005293;\n    transition: padding 0.2s ease; /* Smooth transition for padding */\n    font-weight: 900;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */\n    text-shadow: 0px 0px 0px #008cff;\n  }\n    .button:hover {\n      /* box-shadow: -4px -4px 0px #00C6FF, 4px 4px 0px #EE1D52; Add two drop shadows */\n      box-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff0000, 0 0 70px #ff0000, 0 0 80px #ff0000, 0 0 100px #ff0000, 0 0 150px #ff00de;\n      text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff0000, 0 0 70px #ff0000, 0 0 80px #ff0000, 0 0 100px #ff0000, 0 0 150px #ff00de;\n      border: 1px solid red;\n      background-color: rgba(0, 0, 255, 0.0);\n      color: red;\n\n      cursor: pointer; /* Change cursor on hover */\n    }\n\n    .headings {\n      position: relative;\n      clear:left;\n      display: block;\n      text-align: center;\n    }\n  \n  \n  .App {\n    width: 100%;\n    height: 100%;\n    position: relative;\n  }\n  \n    h1,\n    p {\n      position: relative;\n      z-index: 1;\n      text-align: center;\n    }\n    \n    @keyframes float {\n      0% {\n        transform: translateY(0);\n      }\n      50% {\n        transform: translateY(-10px);\n      }\n      100% {\n        transform: translateY(0);\n      }\n    }\n    .circle {\n      animation-name: float;\n      animation-duration: 3s;\n      animation-iteration-count: infinite;\n      animation-timing-function: ease-in-out;\n    }\n    \n   \n    \n   \n    .icon{\n      width: 19px;\n      height: 24;\n      float:left;\n    }\n    \n    .box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    \n    .spinner-border.custom-spinner {\n      color: blue;\n    }\n    #imageCarousel{\n      width: 100%;\n      position: relative;\n      display: block;\n      padding: 1% 1%;\n      border: 1px;\n      border: 3px solid #ffffff;\n      margin-top: 10px;\n    }  \n    \n    h1, h2, h3, h4 {\n      font-family: 'Roboto';\n      color: var(--text-colour);\n    }   \n    \n    \n    .leftAlign {\n    display: block; /* remove any default spacing and padding */\n    max-width: 15%; /* ensure the images scale properly */\n    height: auto; /* maintain aspect ratio */\n    padding-right:20px;\n    \n  }\n  \n  .rightAlign {\n    display: block; /* remove any default spacing and padding */\n    max-width: 400px; /* ensure the images scale properly */\n    height: auto; /* maintain aspect ratio */\n    padding-left: 20px;\n  }\n  \n  .gif{\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n      width: 50%;\n      height: auto;\n      border: 3px solid var(--text-colour);\n    }\n    \n    \n  \n  \n  hr { \n    /* border: 3px solid #ffffff; */\n    width: 20%;\n    border-color: \"blue\";\n  } \n\nh3 {\n  text-align: center;\n}\n\n#blurb button {\n  \n}\n\n/* h1 span #logoText {\n  font-family: 'Roboto' !important;\n  letter-spacing: 1px;\n  transition: padding 0.2s ease;\n  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;\n  /* font-size: large !important; \n} \n*/\n\n\n.logoText {\n  font-family: 'Roboto' !important;\n  letter-spacing: 1px;\n  transition: padding 0.2s ease;\n  color: #fecb00;\n  font-size: 58px;\n}\n\n@media screen and (max-width: 400px) {\n  .logoText {\n    font-family: 'Roboto' !important;\n    letter-spacing: 1px;\n    transition: padding 0.2s ease;\n    color: #fecb00;\n    font-size: 30px;\n  }\n\n}\n\n@media screen and (max-width: 768px) {\n  .logoBanner {\n    width: 400px;\n    justify-content: center;\n    display: flex;\n  }\n\n}\n\n.logoBanner {\n  max-width: 100%;\n  border-radius: 40px;\n  \n}\n\nul {\n  text-align: center;\n  list-style: none;\n  padding-left: 0;\n  margin-left: 0;\n}\n\n.buttonWrapper {\n  justify-content: right !important;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n@media screen and (max-width: 768px) {\n  .buttonWrapper {\n    justify-content: center !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageBlackBorder": `MO_cswAEVtkSFjq1URgw`,
	"button": `ZlzcpuLFRoUJUAOfu_OI`,
	"headings": `wyvJIEH_QPeg448IwMd1`,
	"App": `IZHONrumCyswcVyir15N`,
	"circle": `moUMC4FeilyAryZm2VQu`,
	"float": `XZQDsjrcPZi9xamLTfUJ`,
	"icon": `TBoRdF056cAKiJytuM3G`,
	"box": `RerkZUf4a3bGKaQe66MS`,
	"spinner-border": `xImlrI8EtvkGrREygP4s`,
	"custom-spinner": `U0gYyJeZCNHw7ouxPy6_`,
	"imageCarousel": `rbqrO8mQzSomQ11rTyPQ`,
	"leftAlign": `_31diwsPwba1bK3L9DaR2`,
	"rightAlign": `JsTLJw2P_URCzRwAvAl9`,
	"gif": `CUsH8xvzrJ9spVDoTG8B`,
	"blurb": `dmwySiaGDAcZbk0tk9qC`,
	"logoText": `g3qQHxk0LDUI8m3CUWTG`,
	"logoBanner": `MkClfXFHp3oRZK7byVW1`,
	"buttonWrapper": `mTYjHSQcOpMipa3wxA2Z`
};
export default ___CSS_LOADER_EXPORT___;
